import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import useFilters from '@hooks/useFilters'
import type { UseFiltersPayload } from '@hooks/useFilters'

import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

export type PageContextPayload = UseFiltersPayload & {
}

const List = () => {

  useLocation()

  const filtersPayload = useFilters({
    persistFilters: true,
  })

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent pageFilters={pageFilters} />
    </PageContext.Provider>
  )
}

export default List
